import { currentTab } from '../state'

/**
 * Change the active tab
 * @param {string} tabName - Name of the tab to activate
 * @param {Object} route - Vue Router route object
 * @param {Object} router - Vue Router instance
 */
export const changeTab = (tabName, route, router) => {
  if (!tabName) {
    console.error('Tab name is required to change tabs')
    return
  }
  
  try {
    currentTab.value = tabName
    router.push({ query: { ...route.query, tab: tabName } })
  } catch (error) {
    console.error('Error changing tab:', error)
  }
}
